import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { NavButton } from 'components/Button'
import { MainHeadline } from 'components/Typography'
import { InvoiceCard } from 'components/Card'

const InvoicesTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'請求書'} />
      <Spacer size={20} />
      <InvoiceCard />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default InvoicesTemplate
